// src/app/state/effects/theme.effects.ts
import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, withLatestFrom } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { AppState } from '../app.state';
import { ThemeService } from '../../core/services/theme.service';
import * as ThemeActions from '../actions/theme.actions';
import { ThemeData } from '../models/theme.model';

@Injectable()
export class ThemeEffects {
  changeToDarkTheme$;
  changeToLightTheme$;
  setInitialTheme$;

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private themeService: ThemeService
  ) {
    // Effect for changing to dark theme
    this.changeToDarkTheme$ = createEffect(
      () =>
        this.actions$.pipe(
          ofType(ThemeActions.changeToDarkTheme),
          map(() => this.themeService.switchTheme('theme-dark'))
        ),
      { dispatch: false }
    );

    // Effect for changing to light theme
    this.changeToLightTheme$ = createEffect(
      () =>
        this.actions$.pipe(
          ofType(ThemeActions.changeToLightTheme),
          map(() => this.themeService.switchTheme('theme-light'))
        ),
      { dispatch: false }
    );

    // Effect to set initial theme on application startup
    this.setInitialTheme$ = createEffect(
      () =>
        this.actions$.pipe(
          ofType('@ngrx/effects/init'), // Triggers on app initialization
          withLatestFrom(this.store.pipe(select('theme'))),
          map(([_, themeState]: [any, ThemeData]) => {
            this.themeService.switchTheme(themeState.theme);
          })
        ),
      { dispatch: false }
    );
  }
}
